import Pages from "./Pages";
import './App.css';

function App() {
  return <Pages />;
}

export default App;
